var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alpheios-notification-area" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showHint,
            expression: "showHint",
          },
        ],
        staticClass: "alpheios-notification-area__hint",
      },
      [
        _c("div", {
          staticClass: "alpheios-notification-area__msg",
          domProps: { innerHTML: _vm._s(_vm.$store.state.ui.hint.text) },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "alpheios-notification-area__close-btn",
            on: {
              click: function ($event) {
                return _vm.$store.commit("ui/resetHint")
              },
            },
          },
          [_c("close-icon")],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showNotification,
            expression: "showNotification",
          },
        ],
        staticClass: "alpheios-notification-area__notification",
        class: _vm.notificationClasses,
      },
      [
        _c("div", {
          staticClass: "alpheios-notification-area__msg",
          domProps: {
            innerHTML: _vm._s(_vm.$store.state.ui.notification.text),
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "alpheios-notification-area__control-cont" },
          [
            _c("setting", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.$store.state.ui.notification.showLanguageSwitcher,
                  expression:
                    "$store.state.ui.notification.showLanguageSwitcher",
                },
              ],
              attrs: {
                classes: ["alpheios-notification-area__control"],
                data: _vm.settings.getFeatureOptions().items.preferredLanguage,
                "selected-override": _vm.$store.state.app.currentLanguageName,
                "show-title": false,
                "show-label-text": false,
              },
              on: { change: _vm.featureOptionChanged },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "alpheios-notification-area__close-btn",
                on: {
                  click: function ($event) {
                    return _vm.$store.commit("ui/resetNotification")
                  },
                },
              },
              [_c("close-icon")],
              1
            ),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.$store.state.lexis.treebankRefreshFailed,
            expression: "$store.state.lexis.treebankRefreshFailed",
          },
        ],
        staticClass: "alpheios-notification-area__hint",
      },
      [
        _c("div", { staticClass: "alpheios-notification-area__msg" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.l10n.getMsg("TEXT_TREEBANK_NOT_AVAILABLE")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "alpheios-notification-area__close-btn",
            on: { click: _vm.hideTreebankNotification },
          },
          [_c("close-icon")],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.cedictNotificationIsVisible,
            expression: "cedictNotificationIsVisible",
          },
        ],
        staticClass: "alpheios-notification-area__hint",
        class: _vm.cedictNotificationClasses,
      },
      [
        _c("div", { staticClass: "alpheios-notification-area__msg" }, [
          _vm._v("\n      " + _vm._s(_vm.cedictNotificationMessage) + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "alpheios-notification-area__controlbox " }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showCedictLoadDataBtn,
                  expression: "showCedictLoadDataBtn",
                },
              ],
              staticClass:
                "alpheios-button alpheios-notification-area__hint-btn",
              on: { click: _vm.loadCedictData },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.l10n.getMsg("LABEL_CEDICT_LOAD_DATA_BTN")) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "alpheios-notification-area__close-btn",
            on: { click: _vm.hideCedictNotification },
          },
          [_c("close-icon")],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showLoginNotification,
            expression: "showLoginNotification",
          },
        ],
        staticClass:
          "alpheios-notification-area__notification alpheios-notification-area__notification--important alpheios-notification-area__login-notification",
      },
      [
        _c("div", {
          staticClass: "alpheios-notification-area__msg",
          domProps: {
            innerHTML: _vm._s(
              _vm.l10n.getMsg(_vm.$store.state.auth.notification.text)
            ),
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "alpheios-notification-area__controlbox " },
          [
            _c("login", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.app.platform.isSafariAppExtension,
                  expression: "!app.platform.isSafariAppExtension",
                },
              ],
              staticClass: "alpheios-notification-area__control",
              attrs: { "btn-class": "alpheios-button-primary" },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.app.platform.isSafariAppExtension &&
                      this.$store.state.ui.activeTab !== "user",
                    expression:
                      "app.platform.isSafariAppExtension && this.$store.state.ui.activeTab!=='user'",
                  },
                ],
                staticClass: "alpheios-button-primary",
                on: { click: _vm.showUserAccount },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.l10n.getMsg("AUTH_USER_ACCOUNT_BTN_LABEL")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.$store.state.auth.hideLoginPrompt &&
                      _vm.$store.state.auth.notification.count >= 2,
                    expression:
                      "!$store.state.auth.hideLoginPrompt && $store.state.auth.notification.count >= 2",
                  },
                ],
                staticClass: "alpheios-button-tertiary",
                on: { click: _vm.hideLoginPrompt },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.l10n.getMsg("AUTH_HIDE_LOGIN_BTN_LABEL")) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "alpheios-notification-area__close-btn",
            on: {
              click: function ($event) {
                return _vm.$store.commit("auth/resetNotification")
              },
            },
          },
          [_c("close-icon")],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }